// extracted by mini-css-extract-plugin
export var container = "_ao-0";
export var content = "_ao-3";
export var customerTitle = "_ao-4";
export var empty = "_ao-5";
export var gray = "_ao-6";
export var header = "_ao-7";
export var info = "_ao-8";
export var loading = "_ao-2";
export var loadingCard = "_ao-9";
export var oneLine = "_ao-a";
export var personName = "_ao-e";
export var pillContainer = "_ao-b";
export var selected = "_ao-1";
export var text = "_ao-c";
export var twoLines = "_ao-d";
export var unread = "_ao-f";
export var unreadIndicator = "_ao-g";